import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import errorActions from '../actions';
import ErrorBoundary from './error-boundary';

const mapStateToProps = (state) => ({
  sendingError: state.errors.sendingError,
  hasError: state.errors.hasError,
});

const mapDispatchToProps = (dispatch) => ({
  doReportError(title, formId, error, errorMessage) {
    dispatch(errorActions.doReportError(title, formId, error, errorMessage));
  },
  setErrorState(status) {
    dispatch(errorActions.setErrorState(status));
  },
});

const ConnectedErrorBoundary = withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary));

export default ConnectedErrorBoundary;
